import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";

const CaseSelectionImageViewModal = React.forwardRef((props, ref) => {
  const [zoom, setZoom] = useState(1); // 1 = 100%

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const handleZoomIn = () => {
    setZoom((prev) => prev + 0.2); // increase by 20%
  };

  const handleZoomOut = () => {
    setZoom((prev) => Math.max(0.2, prev - 0.2)); // decrease, min 20%
  };

  return (
    <Modal
      {...props}
      size="xl"
      ref={ref}
      centered
      dialogClassName="modal-90w" // extra wide modal
    >
      <Modal.Header closeButton>
        <Modal.Title>Case Image Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: "80vh" }}>
        {/* Zoom buttons */}
        <div className="d-flex justify-content-end mb-2 gap-2">
          <button className="btn btn-secondary" onClick={handleZoomOut}>
            -
          </button>
          <button className="btn btn-secondary" onClick={handleZoomIn}>
            +
          </button>
        </div>

        {/* Scrollable container */}
        <div
          style={{
            width: "100%",
            height: "calc(100% - 40px)", // leave space for zoom buttons
            overflow: "auto",
            border: "1px solid #ccc",
            borderRadius: "10px",
          }}
        >
          {props.viewImage ? (
            <img
              src={props.viewImage}
              alt="Case Preview"
              style={{
                transform: `scale(${zoom})`,
                transformOrigin: "top left",
                display: "block",
              }}
            />
          ) : (
            <p>No image selected</p>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default CaseSelectionImageViewModal;
